export const en = {
    'high-priority': 'High',
    'low-priority': 'Low',
    'medium-priority': 'Medium',
    'replace-validation-error-invalid-characters': 'Separate negative keywords with a space. Do not use "-" or ",".',
    'status-active': 'Active',
    'status-archived': 'Archived',
    'status-draft': 'Draft',
    'status-reject-by-moderator': 'Keyword rejected at moderation',
    'status-stopped': 'Stopped'
};
